import { getUserState } from '@carvana/core-auth';
import sendBeacon from './sendBeacon';
import sendFetch from './sendFetch';
import getEnvelope from './envelope';
import constructData from './constructData';
import { EventData, WeapiEventPayload } from './contracts';

const startTracking = (
  env,
  url,
  track,
  project,
  correlationId,
  payloadMetaAttributes,
  debug,
) => {
  const getPayload = async data => {
    const userState = getUserState();
    const is_impersonating = userState?.impersonation?.is_impersonating;
    const { eventName, customAttributes = {}, overrides = {} } = data || {};

    const envelope = await getEnvelope({
      environment: env,
      project,
      track,
      eventName,
      correlationIdOverride: correlationId,
      overrides,
      isImpersonating: is_impersonating || false,
    });

    const eventPayload: WeapiEventPayload = constructData(
      envelope,
      customAttributes,
      payloadMetaAttributes,
    );

    return eventPayload;
  };

  const trackData = async data => {
    const { eventName, options = {} } = data || {};
    const { useFetch = false, fetchOption = { keepalive: true } } = options;

    const eventPayload = await getPayload(data);

    const fullData: EventData = {
      query: `mutation weapiEvent($EventPayload: EventPayload!) { event( payload: $EventPayload ) }`,
      operationName: 'weapiEvent',
      variables: { EventPayload: eventPayload },
    };
    const isProdLikeEnv =
      env === 'production' || env === 'prod' || env === 'uat';

    if (debug && !isProdLikeEnv) {
      console.debug(
        `Eventable clickstream payload for ${eventName}: `,
        eventPayload,
      );
    }

    if (
      typeof window !== 'undefined' &&
      'sendBeacon' in navigator &&
      !useFetch
    ) {
      sendBeacon(`${url}?${eventName}`, fullData);
    } else {
      sendFetch(`${url}?${eventName}`, fullData, fetchOption);
    }
  };

  return { trackData, getPayload };
};

export const startTrackingWithoutPayload = (
  env,
  url,
  track,
  project,
  correlationId,
  payloadMetaAttributes,
  debug,
) => {
  const { trackData } = startTracking(
    env,
    url,
    track,
    project,
    correlationId,
    payloadMetaAttributes,
    debug,
  );

  return trackData;
};

export default startTracking;
